import { Component, ElementRef, Input, Optional, Renderer2, Self, ViewChild, HostBinding } from "@angular/core";
import { NgControl } from "@angular/forms";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-textarea",
    templateUrl: "./sps-textarea.component.html",
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsTextareaComponent }]
})
export class SpsTextareaComponent extends SpsFormControlComponent<string> {
    static readonly displayName = "sps-textarea";
    static readonly props = {
        placeholder: "string",
        rows: "number",
    };

    @Input() placeholder = "";
    @Input() rows = 2;

    @HostBinding("class.sps-form-group") readonly spsFormGroupClass = true;
    @HostBinding("class.d-block") readonly dBlockClass = true;

    @ViewChild("textarea", { static: false }) inputElement: ElementRef;

    get value(): string {
        return this.model;
    }
    set value(newValue: string) {
        this.model = newValue;
    }

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl
    ) {
        super(el, renderer, ngControl);
    }
}
